(function($) {
    $(() => {
		$('.gallery').find('br').remove();
		$('.gallery').slick({
		    prevArrow: '<i class="fal fa-chevron-left prev-arrow"></i>',
		    nextArrow: '<i class="fal fa-chevron-right next-arrow"></i>',
            adaptiveHeight: true
		});

		$('.gallery-short').click(function(){
		 	$(this).next().find('a.gallery-lightbox').first().trigger('click');
		});

		let $grid = $('.masonry').masonry({
			itemSelector: '.masonry-item',
			transitionDuration: 0
		});

		$grid.imagesLoaded().progress( function() {
			$grid.masonry('layout');
		});		  
    });
})(jQuery);
